import { render, staticRenderFns } from "./MobilePaymentView.vue?vue&type=template&id=bb1ce14e&scoped=true&"
import script from "./MobilePaymentView.vue?vue&type=script&lang=js&"
export * from "./MobilePaymentView.vue?vue&type=script&lang=js&"
import style0 from "./MobilePaymentView.vue?vue&type=style&index=0&id=bb1ce14e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1ce14e",
  null
  
)

export default component.exports